var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.skill ? _c('div', {
    staticClass: "px-4"
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('No Passive Skill')
    }
  })], 1) : _c('div', [_c('div', {
    staticClass: "px-4"
  }, [_c('span', [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('Skill Name'),
      "v": _vm.skill.m_SkillName || _vm.$t('Passive Skill'),
      "width": "33%"
    }
  }), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "mr-2 d-flex justify-center flex-column"
  }, [_c('v-img', {
    attrs: {
      "width": _vm.$size(),
      "contain": "",
      "src": _vm.icon
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-center flex-column small",
    style: {
      'width': "calc(100% - ".concat(_vm.$size(), "px)"),
      'min-height': "".concat(_vm.$size(), "px")
    }
  }, _vm._l(_vm.contents, function (content, j) {
    return _c('div', {
      key: "passive-skill-".concat(_vm.id, "-content-").concat(j),
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "pr-1"
    }, [_vm._v("・")]), _c('div', _vm._l(content, function (item, k) {
      return _c('div', {
        key: "passive-skill-".concat(_vm.id, "-content-").concat(j, "-item-").concat(k),
        domProps: {
          "innerHTML": _vm._s(item)
        }
      });
    }), 0)]);
  }), 0)])], 1), _c('v-col', {
    staticClass: "py-0 hidden-lg-and-down",
    attrs: {
      "cols": "3"
    }
  }, [_c('KeyValue', {
    attrs: {
      "k": _vm.$t('Load'),
      "v": "-"
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Recast'),
      "v": "-"
    }
  }), _c('KeyValue', {
    attrs: {
      "k": _vm.$t('Charge'),
      "v": "-"
    }
  })], 1)], 1), _c('div', {
    staticClass: "pb-3"
  }), _vm.skillChangeIDs[1] != -1 ? _c('Skill', {
    key: "passive-skill-".concat(_vm.id, "-skill-change-", 1),
    attrs: {
      "id": _vm.skillChangeIDs[1],
      "from": _vm.characterSkillIDs[1],
      "owner": "PL",
      "max": "25"
    }
  }) : _vm._e(), _vm.skillChangeIDs[2] != -1 ? _c('Skill', {
    key: "passive-skill-".concat(_vm.id, "-skill-change-", 2),
    attrs: {
      "id": _vm.skillChangeIDs[2],
      "from": _vm.characterSkillIDs[2],
      "owner": "PL",
      "max": "25"
    }
  }) : _vm._e(), _vm.skillChangeIDs[0] != -1 ? _c('Skill', {
    key: "passive-skill-".concat(_vm.id, "-skill-change-", 0),
    attrs: {
      "id": _vm.skillChangeIDs[0],
      "from": _vm.characterSkillIDs[0],
      "owner": "PL"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }